import { Navigate, Outlet, useLocation } from "react-router-dom";
import { useAuthStore } from "@/store/auth.store";
import { ROUTES } from "@/constants/routes";

export default function ProtectedRoute() {
  const location = useLocation();

  const isAuthenticated = useAuthStore((state) =>
    state.isAuthenticated(),
  );

  if (!isAuthenticated) {
    return (
      <Navigate
        to={ROUTES.adminLogin}
        replace
        state={{ from: location }}
      />
    );
  }

  return <Outlet />;
}